export const styles = {
  gap: {
    small: '8px',
    medium: '15px',
    large: '30px',
  },
};
